import { useRecoilValue } from "recoil";
// atoms
import userAtom from "src/recoil/atoms/userAtom";
// utils
import createAvatar from "src/utils/createAvatar";
//
import Avatar from "./Avatar";

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const user = useRecoilValue(userAtom);

  return (
    <Avatar
      src={user?.profile_pic}
      alt={`${user?.first_name} ${user?.last_name}`}
      color={
        user?.profile_pic
          ? "default"
          : createAvatar(`${user?.first_name} ${user?.last_name}`).color
      }
      {...other}
    >
      {createAvatar(`${user?.first_name} ${user?.last_name}`).name}
    </Avatar>
  );
}
